import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { Check } from "lucide-react";

export default function BookingConfirmation() {
  const { reference } = useParams();
  const [booking, setBooking] = useState(null);

  useEffect(() => { api.get(`/bookings/${reference}`).then(r => setBooking(r.data)).catch(() => {}); }, [reference]);

  if (!booking) return <div className="p-10 text-slate-500">Loading booking…</div>;

  return (
    <div className="max-w-2xl mx-auto px-5 lg:px-8 py-16">
      <div className="w-14 h-14 rounded-full bg-emerald-100 text-emerald-700 grid place-items-center mx-auto"><Check size={28}/></div>
      <h1 className="font-display text-3xl font-semibold text-center text-[var(--fpn-navy)] mt-6" data-testid="confirmation-title">Your parking is booked.</h1>
      <p className="text-center text-slate-600 mt-2">Reference <span className="font-mono font-semibold" data-testid="confirmation-reference">{booking.reference}</span></p>

      <div className="mt-10 border border-slate-200 rounded-2xl p-6 bg-white space-y-4 text-sm">
        <Row label="Parking" value={booking.parking_name}/>
        <Row label="Airport" value={booking.airport_code}/>
        <Row label="Drop-off" value={new Date(booking.dropoff).toLocaleString("en-GB")}/>
        <Row label="Pick-up" value={new Date(booking.pickup).toLocaleString("en-GB")}/>
        <Row label="Vehicle" value={`${booking.vehicle_make} ${booking.vehicle_model} · ${booking.vehicle_registration}`}/>
        <Row label="Total paid" value={`£${booking.total_price.toFixed(2)}`}/>
        {booking.revealed_address && <Row label="Address" value={booking.revealed_address}/>}
      </div>

      <Link to="/" className="btn-navy inline-block rounded-full px-6 py-3 text-sm mt-8" data-testid="confirmation-home">Back to home</Link>
    </div>
  );
}

const Row = ({ label, value }) => (
  <div className="flex justify-between gap-4">
    <span className="text-slate-500">{label}</span>
    <span className="text-right font-medium text-slate-800">{value}</span>
  </div>
);
